import { render, staticRenderFns } from "./typingSecond.vue?vue&type=template&id=3aefc3c0&"
import script from "./typingSecond.vue?vue&type=script&lang=js&"
export * from "./typingSecond.vue?vue&type=script&lang=js&"
import style0 from "./typingSecond.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports